var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgB2BLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "156px",
    height: "45px",
    viewBox: "0 0 156 45",
    enableBackground: "new 0 0 156 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M6.439,14.584H4.288v4.883H2.169V7.879h2.119v4.85h2.218l3.328-4.85h2.284l-3.956,5.612l4.105,5.976H9.834 L6.439,14.584z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M16.103,18.863c-0.95-0.513-1.695-1.225-2.235-2.136c-0.542-0.91-0.811-1.928-0.811-3.054 c0-1.125,0.27-2.143,0.811-3.053c0.54-0.912,1.285-1.623,2.235-2.136c0.949-0.513,2.014-0.771,3.194-0.771 c1.181,0,2.246,0.257,3.195,0.771c0.949,0.513,1.694,1.222,2.234,2.127c0.541,0.904,0.812,1.925,0.812,3.062 c0,1.137-0.271,2.158-0.812,3.063c-0.54,0.905-1.286,1.614-2.234,2.127c-0.95,0.513-2.014,0.77-3.195,0.77 C18.117,19.633,17.052,19.376,16.103,18.863z M21.383,17.224c0.618-0.347,1.103-0.833,1.457-1.457 c0.354-0.623,0.53-1.321,0.53-2.094c0-0.772-0.176-1.47-0.53-2.093c-0.354-0.624-0.838-1.109-1.457-1.458 c-0.618-0.347-1.313-0.52-2.086-0.52s-1.468,0.173-2.086,0.52c-0.618,0.349-1.103,0.834-1.457,1.458 c-0.354,0.623-0.53,1.321-0.53,2.093c0,0.773,0.176,1.471,0.53,2.094c0.354,0.624,0.839,1.109,1.457,1.457 c0.618,0.348,1.313,0.521,2.086,0.521S20.766,17.572,21.383,17.224z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M38.769,19.467l-0.017-7.682l-3.808,6.357h-0.96l-3.807-6.258v7.582h-2.036V7.879h1.771l4.586,7.665 l4.536-7.665h1.755l0.033,11.588H38.769z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M54.819,19.467l-0.017-7.682l-3.808,6.357h-0.96l-3.807-6.258v7.582h-2.036V7.879h1.771l4.585,7.665 l4.536-7.665h1.755l0.033,11.588H54.819z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M68.924,17.663v1.804h-8.691V7.879h8.459v1.804h-6.307v3.013h5.594v1.771h-5.594v3.195H68.924z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M78.852,8.376c0.746,0.331,1.317,0.806,1.714,1.423c0.396,0.618,0.596,1.352,0.596,2.202 c0,0.839-0.199,1.57-0.596,2.193c-0.397,0.624-0.969,1.101-1.714,1.433c-0.744,0.331-1.619,0.497-2.624,0.497h-2.615v3.344h-2.152 V7.879h4.767C77.233,7.879,78.108,8.045,78.852,8.376z M78.265,13.706c0.486-0.397,0.729-0.965,0.729-1.705 s-0.243-1.309-0.729-1.706C77.779,9.899,77.067,9.7,76.13,9.7h-2.517v4.603h2.517C77.067,14.302,77.779,14.104,78.265,13.706z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M92.907,7.879v11.588h-2.136v-4.37c-1.093,0.409-2.129,0.612-3.112,0.612 c-1.479,0-2.617-0.355-3.418-1.067c-0.8-0.712-1.2-1.735-1.2-3.071V7.879h2.136v3.459c0,0.817,0.237,1.44,0.712,1.871 c0.474,0.431,1.153,0.646,2.036,0.646c1.004,0,1.953-0.204,2.847-0.612V7.879H92.907z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M104.967,17.663v1.804h-8.69V7.879h8.459v1.804h-6.307v3.013h5.594v1.771h-5.594v3.195H104.967z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M109.526,18.863c-0.945-0.513-1.685-1.222-2.219-2.127c-0.536-0.904-0.804-1.925-0.804-3.063 c0-1.136,0.271-2.158,0.812-3.062c0.54-0.905,1.282-1.614,2.226-2.127c0.945-0.513,2.001-0.771,3.171-0.771 c0.949,0,1.815,0.166,2.6,0.497c0.783,0.332,1.444,0.812,1.986,1.44l-1.391,1.309c-0.839-0.905-1.87-1.357-3.096-1.357 c-0.794,0-1.507,0.173-2.136,0.52c-0.63,0.349-1.12,0.832-1.474,1.45c-0.354,0.618-0.529,1.319-0.529,2.102 c0,0.784,0.176,1.484,0.529,2.103c0.354,0.619,0.844,1.101,1.474,1.448c0.629,0.348,1.342,0.521,2.136,0.521 c1.226,0,2.257-0.457,3.096-1.374l1.391,1.325c-0.542,0.628-1.206,1.108-1.995,1.44c-0.789,0.331-1.658,0.497-2.607,0.497 C111.525,19.633,110.47,19.376,109.526,18.863z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M123.785,14.584h-2.151v4.883h-2.119V7.879h2.119v4.85h2.218l3.328-4.85h2.284l-3.956,5.612l4.105,5.976 h-2.434L123.785,14.584z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M140.114,16.785h-5.794l-1.143,2.682h-2.218l5.214-11.588h2.119l5.231,11.588h-2.252L140.114,16.785z  M139.402,15.097l-2.186-5.065l-2.168,5.065H139.402z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M154.833,7.879v11.588h-2.119v-3.229h-2.863h-0.231l-2.152,3.229h-2.268l2.482-3.576 c-0.806-0.298-1.427-0.77-1.861-1.416c-0.437-0.646-0.654-1.426-0.654-2.342c0-0.883,0.198-1.645,0.596-2.285 c0.397-0.64,0.96-1.128,1.689-1.465c0.728-0.337,1.583-0.505,2.565-0.505H154.833z M148.055,10.313 c-0.469,0.409-0.703,1.005-0.703,1.789c0,0.761,0.226,1.349,0.679,1.762c0.452,0.414,1.109,0.621,1.97,0.621h2.714V9.7h-2.631 C149.2,9.7,148.523,9.904,148.055,10.313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M10.578,27.773h-3.84v9.767H4.603v-9.767H0.779v-1.822h9.799V27.773z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M21.405,35.736v1.804h-8.691V25.951h8.459v1.806h-6.307v3.013h5.595v1.771h-5.595v3.195H21.405z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M25.828,25.951l2.732,3.875l2.73-3.875h2.517l-3.89,5.563l4.205,6.025h-2.549l-3.013-4.222l-2.997,4.222 h-2.483l4.188-5.942l-3.923-5.646H25.828z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M46.536,25.951V37.54h-2.151v-4.966h-5.993v4.966H36.24V25.951h2.152v4.785h5.993v-4.785H46.536z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M49.908,25.951h2.119v8.228l6.224-8.228h2.003V37.54h-2.119v-8.211l-6.224,8.211h-2.003V25.951z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M67.894,32.657h-2.151v4.883h-2.119V25.951h2.119v4.852h2.218l3.328-4.852h2.284l-3.956,5.613l4.105,5.976 h-2.433L67.894,32.657z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M84.223,34.859h-5.794l-1.143,2.681h-2.218l5.214-11.589h2.119l5.231,11.589h-2.252L84.223,34.859z  M83.511,33.169l-2.186-5.065l-2.168,5.065H83.511z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB2BLogoWhite);
export default ForwardRef;